<template>
  <div class="bm-field" :data-qa="dataQaVal">
    <label class="bm-field-label">{{ labelVal }}</label>
    <template v-if="tooltipVal">
      <bm-tooltip bottom>
        <span>{{ tooltipVal }}</span>
      </bm-tooltip>
    </template>
    <div><slot /></div>
  </div>
</template>

<script lang="ts">
import BmTooltip from "@/components/controls/input/BmTooltip.vue";
import { useBmLabelled } from "@/components/controls/input/mixins/BmLabelled";
import type Key from "@/app/types/common/key";
import { defineComponent } from "vue";
import type { PropType } from "vue";

export default defineComponent({
  name: "BmReadOnlyField",
  components: { BmTooltip },
  inheritAttrs: false,
  props: {
    label: { type: String, default: null, required: false },
    tooltip: { type: String, default: null, required: false },
    t: { type: Object as PropType<Key>, default: undefined, required: false },
    dataQa: { type: [Object, String], default: undefined, required: false },
  },
  setup(props) {
    const { labelVal, tooltipVal, dataQaVal } = useBmLabelled(() => props);

    return {
      labelVal,
      tooltipVal,
      dataQaVal,
    };
  },
});
</script>

<style scoped lang="sass">
.v-tooltip
  margin-left: 5px
</style>
